import { FieldProperties } from "./Field";
import NoCheckInField from "./NoCheckInField";

class NoVerifiedCheckInField extends NoCheckInField {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      ...data,
      platformFilterNames: ["lastVerifiedCheckIn"],
      valueGetter: ["lastVerifiedCheckIn", "completedAt"],
    });
  }
}

export default NoVerifiedCheckInField;
